import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getGlobalVariablesByCountry } from './utils';
import { useGetGlobalVariablesValues } from './useAddGlobalVariables';
import { countrySelector } from '@xarvio/frontend-core-state/lib/intl/selectors';
import { ATInternetCustomObjectField } from './constants';

export const useSetConfiguredTag = () => {
  const countryCode = useSelector(countrySelector);

  const globalVariables = getGlobalVariablesByCountry(countryCode);
  const getValues = useGetGlobalVariablesValues();

  useEffect(() => {
    if (!window.ATInternet || window.ATInternetData?.tag) {
      return;
    }

    let config: any;

    if (
      globalVariables.length &&
      globalVariables.includes(ATInternetCustomObjectField.USER_ID)
    ) {
      config = {
        ClientSideUserId: {
          clientSideMode: 'always',
          userIdCookieDuration: 397,
          userIdExpirationMode: 'fixed',
        },
      };
    }

    let customObject: any;
    let context: any;

    if (globalVariables.length > 0) {
      customObject = getValues(globalVariables);
    }

    if (customObject) {
      context = {
        userIdentifier: customObject[ATInternetCustomObjectField.USER_ID],
      };
    }

    const trackerTag: any = new window.ATInternet.Tracker.Tag(config, context);

    if (globalVariables.length > 0) {
      if (customObject?.[ATInternetCustomObjectField.USER_ID]) {
        trackerTag.clientSideUserId.set(
          customObject[ATInternetCustomObjectField.USER_ID],
        );
      }

      trackerTag.page.set({ customObject });
      trackerTag.identifiedVisitor?.set({
        id: customObject[ATInternetCustomObjectField.USER_ID],
      });

      trackerTag.dispatch();
    }

    window.ATInternetData = {
      tag: trackerTag,
      customObject,
    };
  }, [getValues, globalVariables, window.ATInternet]); // eslint-disable-line react-hooks/exhaustive-deps

  return;
};
